import {  useRef } from "react";
import Select from "react-dropdown-select";
import CustomDropdown from './CustomDropdown';
import CustomControl from './CustomControl';
import CustomDropdownWithSearch from './CustomDropdownWithSearch';
import CustomControlMulti from './CustomControlMulti';
import CustomDropdownMulti from './CustomDropdownMulti';
import DebounceInput from 'react-debounce-input';
import { capitalizeWordsText } from "../Functions/TextTransform";

export default function SelectedMotorizedStepDraperyOnly({
  trackType8B,
  motorErr1,
  t,
  step8B6,
  selectChanged,
  setStep8B6,
  setMotorErr1,
  setSelectedMotorPositionB,
  setSelectedRemoteName,
  setSelectedMotorChannelsB,
  motorChannels,
  pageLanguage,
  setRemoteNameB,
  setDeps,
  setCart,
  selectUncheck,
  inputs,
  modalHandleShow,
  selectedMotorPositionB,
  selectedRemoteName,
  selectedMotorChannelsB,
  remoteNames,
  showRemoteName,
  Capitalize,
  pageLoad,
  rodsLoad,
  rodsLoad2,
  RemoteNameA,
  MotorPosition,
  setShowRemoteName,
  setCartLoading,
  extendedTitle,
  remoteNameB
}) {
  const motorChannelsUserOpenRefA = useRef(false);
  return (
   <div className={trackType8B === 1 ? "tracks_motorized_section" : "noDisplay"}>
   <div
     className={
       motorErr1
         ? "secondary_options secondary_options_err"
         : "secondary_options"
     }
   >
     <div className="card-body-display-flex">
       <div className="width_max checkbox_style">
         <input
           type="checkbox"
           text={t("Motorized")}
           value="1"
           name="step8B6"
           ref-num="8B5"
           checked={step8B6 === "true"}
           onChange={(e) => {
             if (e.target.checked) {
               selectChanged(e);
               setStep8B6("true");
               setMotorErr1(false);
               setSelectedMotorPositionB([]);
               setDeps('845,846,847' , "85");
               setSelectedRemoteName([]);
               setSelectedMotorChannelsB([
                 motorChannels[pageLanguage].find((opt) => opt.value === "0"),
               ]);
               setRemoteNameB("");
               setCart("hasPowerB", true, "", "MotorChannelsA", [
                 selectedMotorChannelsB.map((obj) => obj.value),
               ]);
             } else {
               selectUncheck(e);
               setStep8B6("");
               setDeps('85' , "845,846,847");
               setCart(
                 "",
                 "",
                 "hasPowerB,MotorPositionA,RemoteNameA,MotorChannelsA"
               );
             }
           }}
           id="8B61"
           ref={(ref) => (inputs.current["8B61"] = ref)}
         />
         <label htmlFor="8B61" className="checkbox_label">
           <img
             className="checkbox_label_img checkmark1 img-fluid"
             src={require("../Images/public/checkmark1_checkbox.png")}
             alt=""
           />
         </label>
         <span className="checkbox_text">{t("Motor_title")}</span>
       </div>
     </div>
   </div>
   {motorErr1 && <div className="input_not_valid">{t("motorErr1")}</div>}
   <div
     className={
       trackType8B === 1 && step8B6 === "true"
         ? "motorized_options"
         : "noDisplay"
     }
   >
     <div className="motorized_option_left">
       <p>{t("Motor Position")}</p>
       &nbsp;
       <span onClick={() => modalHandleShow("learnMore2")}>
         {t("(Learn More)")}
       </span>
     </div>
     <div className="motorized_option_right">
       <div className="select_container">
         <Select
           className="select"
           placeholder={t("Please Select")}
           portal={document.body}
           dropdownPosition="bottom"
           dropdownHandle={false}
           dropdownGap={0}
           ref-num="8"
           values={selectedMotorPositionB}
           onDropdownOpen={() => {
             let temp1 = window.scrollY;
             window.scrollTo(window.scrollX, window.scrollY + 1);
             setTimeout(() => {
               let temp2 = window.scrollY;
               if (temp2 === temp1)
                 window.scrollTo(window.scrollX, window.scrollY - 1);
             }, 100);
           }}
           dropdownRenderer={({ props, state, methods }) => (
             <CustomDropdown props={props} state={state} methods={methods} />
           )}
           contentRenderer={({ props, state, methods }) => (
             <CustomControl props={props} state={state} methods={methods} />
           )}
           onChange={(selected) => {
             if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
            
                setDeps("", "8,8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,8C3,845");
             
               setSelectedMotorPositionB(selected);
               setCart("MotorPositionA", selected[0].value);
               let tempExtended = extendedTitle;
                          tempExtended["8"][2] = (
                            <li key="2" className="step_title_extended_list_item">
                              <span className="step_title_extended_list_item_title">
                                {t("Motor Position")}
                              </span>
                              <span className="step_title_extended_list_item_text">
                                {pageLanguage === "fa" ? selected[0].label : selected[0].value}
                              </span>
                            </li>
                          );
             }
           }}
           options={MotorPosition[pageLanguage]}
         />
       </div>
     </div>
     <div className="motorized_option_left">
       <p>{t("Remote Name")}</p>
       &nbsp;
       <span onClick={() => modalHandleShow("learnMore3")}>
         {t("(Learn More)")}
       </span>
     </div>
     <div className="motorized_option_right">
       {!!(remoteNames.length > 1) && (
         <div className="select_container">
           <Select
             className="select"
             placeholder={t("Please Select")}
             portal={document.body}
             dropdownPosition="bottom"
             dropdownHandle={false}
             ref-num="8"
             dropdownGap={0}
             values={selectedRemoteName}
             onDropdownOpen={() => {
               let temp1 = window.scrollY;
               window.scrollTo(window.scrollX, window.scrollY + 1);
               setTimeout(() => {
                 let temp2 = window.scrollY;
                 if (temp2 === temp1)
                   window.scrollTo(window.scrollX, window.scrollY - 1);
               }, 100);
             }}
             dropdownRenderer={({ props, state, methods }) => (
               <CustomDropdownWithSearch
                 props={props}
                 state={state}
                 methods={methods}
               />
             )}
             contentRenderer={({ props, state, methods }) => (
               <CustomControl props={props} state={state} methods={methods} />
             )}
             onChange={(selected) => {
               if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
                setDeps("", "846");
                 setSelectedRemoteName(selected);
                 if (selected[0]["value"] === "addNewRemoteName") {
                   setShowRemoteName(true);
                   setCart("", "", "RemoteNameA");
                   setRemoteNameB("");
                 } else {
                   setShowRemoteName(false);
                   setCart("RemoteNameA", selected[0]["value"]);
                   setRemoteNameB(selected[0]["value"]);
                 }
               }
             }}
             options={remoteNames}
           />
         </div>
       )}
       {(remoteNames.length === 1 || remoteNames.length === 0) && (
         <DebounceInput
           debounceTimeout={1500}
           onKeyDown={() => setCartLoading(true)}
           className="Remote_name"
           type="text"
           name="Remote_name"
            ref-num="8"
           value={capitalizeWordsText(remoteNameB)}
           placeholder={t("Enter a name for your remote")}
           onChange={(e) => {
             setTimeout(() => {
              setDeps("", "846");
               setCart("RemoteNameA", capitalizeWordsText(e.target.value));
               setRemoteNameB(capitalizeWordsText(e.target.value));
               let tempExtended = extendedTitle;
               tempExtended["8"][3] = (
                 <li key="3" className="step_title_extended_list_item">
                   <span className="step_title_extended_list_item_title">
                     {t("Remote_name")}
                   </span>
                   <span className="step_title_extended_list_item_text">
                     {capitalizeWordsText(e.target.value)}
                   </span>
                 </li>
               );
             }, 300);
           }}
         />
       )}
     </div>
     {showRemoteName && (
       <div className="motorized_option_left">
         <p>&nbsp;</p>
       </div>
     )}
     {showRemoteName && (
       <div className="motorized_option_right">
         <DebounceInput
           debounceTimeout={1500}
           onKeyDown={() => setCartLoading(true)}
           className="Remote_name"
           type="text"
           ref-num="8"
           name="Remote_name"
           value={RemoteNameA}
           placeholder={t("Enter a name for your remote")}
           onChange={(e) => {
             setTimeout(() => {
              setDeps("", "8,8A,8A1,8A2,8B,8B1,8B2,8C,8C1,8C2,8C3,846");
               setCart("RemoteNameA", e.target.value);
               setRemoteNameB(Capitalize(e.target.value));
              
             }, 300);
           }}
         />
       </div>
     )}
     <div className="motorized_option_left">
       <p>{t("Channel(s)")}</p>
       &nbsp;
       <span onClick={() => modalHandleShow("learnMore4")}>
         {t("(Learn More)")}
       </span>
     </div>
     <div className="motorized_option_right">
       <div className="select_container multi_select_container">
         <Select
           className="select select_motor_channels"
           placeholder={t("Please Select")}
           portal={document.body}
           dropdownPosition="bottom"
           dropdownHandle={false}
           dropdownGap={0}
           multi={true}
           ref-num="8"
           values={selectedMotorChannelsB}
           onDropdownOpen={() => {
            motorChannelsUserOpenRefA.current = true;
             let temp1 = window.scrollY;
             window.scrollTo(window.scrollX, window.scrollY + 1);
             setTimeout(() => {
               let temp2 = window.scrollY;
               if (temp2 === temp1)
                 window.scrollTo(window.scrollX, window.scrollY - 1);
             }, 100);
           }}
           dropdownRenderer={({ props, state, methods }) => (
             <CustomDropdownMulti
               props={props}
               state={state}
               methods={methods}
             />
           )}
           contentRenderer={({ props, state, methods }) => (
             <CustomControlMulti props={props} state={state} methods={methods} />
           )}
           onChange={(selected) => {
             if (selected.length && !pageLoad && !rodsLoad && !rodsLoad2) {
              if (motorChannelsUserOpenRefA.current) {
                setDeps("" , "847");
                motorChannelsUserOpenRefA.current = false;
              }
            
               setCart(
                 "MotorChannelsA",
                 selected.map((obj) => obj.value)
               );
               setSelectedMotorChannelsB(selected);
            
               let tempExtended = extendedTitle;
               tempExtended["8"][4] = (
                 <li key="4" className="step_title_extended_list_item">
                   <span className="step_title_extended_list_item_title">
                     {t("Channel(s)")}
                   </span>
                   <span className="step_title_extended_list_item_text">
                   {selected.map(item => pageLanguage === "fa" ? item.label : item.value)
                .join(', ')}
                   </span>
                 </li>
               );
             }
           }}
           options={motorChannels[pageLanguage]}
         />
       </div>
     </div>
   </div>
 </div>
  )
}
